module.exports = __webpack_public_path__ + "img/1447719876.fa858e3a.jpg";